import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import axios from 'axios';
import moment from 'moment';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
// import Divider from 'material-ui/Divider';
import AppBar from 'material-ui/AppBar';
import GameList from './components/game_list';
import Menu from './components/menu';
import DateInput from './components/date_picker';

import './App.css';

import { init } from '@sentry/browser';
 
init({
  dsn: 'https://7df5d07414914acc9155acd7ab55233d@sentry.io/1291428',
});

const dateToday = new Date();
dateToday.setFullYear(dateToday.getFullYear());
dateToday.setDate(dateToday.getDate() - 1);
dateToday.setHours(0, 0, 0, 0);

try {
  injectTapEventPlugin();
} catch (error) {
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      games: [],
      order: 'asc',
      open: false
    };
    this.searchGames(dateToday);
  };
  changeState(games) {
    this.setState({ games: games });
  }
  searchGames = (date) => {
    date = moment(date).format('YYYY-MM-DD');
    axios.get('/schedule', {
      baseURL: 'https://statsapi.web.nhl.com/api/v1/',
      params: {
        startDate: date,
        endDate: date,
        expand: 'schedule.game.content.media.epg'
      }
    })
      .then(gameList => {
        if (gameList.data.dates[0]) {
          this.setState({ games: gameList.data.dates[0].games });
        } else {
          this.setState({ games: null })
        }
      })
      .catch(error => {
        this.setState({ games: null });
      });
  };
  toggleMenu = () => {
    this.setState({
      open: !this.state.open
    });
  };
  changeOrder = (value) => {
    this.setState({
      order: value
    });
  };
  render() {
    return (
      <MuiThemeProvider>
        <div>
          <AppBar
            className="AppBar"
            title="Hockey Highlights"
            onLeftIconButtonTouchTap={this.toggleMenu} />
          <Menu date={dateToday} onDateChange={this.searchGames} order={this.changeOrder} />
          <div className="content">
            <Drawer
              open={this.state.open}
              docked={false}
              width={200}
              onRequestChange={(open) => this.setState({ open })}>
              <MenuItem>NHL</MenuItem>
            </Drawer>
            <div className="content">
              <DateInput date={dateToday} onDateChange={this.searchGames} />
            </div>
            <GameList games={this.state.games} order={this.state.order} />
          </div>
        </div>
      </MuiThemeProvider>
    );
  };
};
export default App;



// WEBPACK FOOTER //
// ./src/App.jsx